var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"podcast"},[_c('head-component'),_vm._v(" "),_c('body-component'),_vm._v(" "),_c('footer-component')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }